import React from "react";
import { Select } from "@cofano/cck";
import { useQuery } from "@apollo/client";
import { GetAllAdnDocument } from "__generated__/view/cargos/graphql/cargo.queries.generated";

const UnNumberSelect = ({ value, onChange, multiple }) => {

	const { data: adnData } = useQuery(GetAllAdnDocument);
	const options = adnData?.allAdn ?? [];

	const getValue = () => {
		if (value && multiple) {
			return options?.filter(item => value.map(item => item.unNumber).includes(item.unNumber));
		} else if (value) {
			return options?.find(item => Number(item.unNumber) === Number(value));
		} else {
			return undefined;
		}
	};

	return (
		<Select
			fetchOptions={options?.map(option => ({ ...option, id: option.unNumber }))}
			onChange={(option) => {
				if (option && multiple) {
					onChange(option);
				} else if (option) {
					onChange(Number(option.unNumber));
				} else {
					return undefined;
				}
			}}
			getOptionLabel={option => option.identifier}
			value={getValue()}
			multiple={multiple}
			renderOption={(props, option) => (
				<li {...props}>
					<div>
						<div>{option.identifier}</div>
						<div>
							<small>{option.descriptionNL}</small>
						</div>
					</div>
				</li>
			)} />
	);
};

export default UnNumberSelect;
